export default "__VITE_ASSET__DrLTNdpY__"